<template>
  <div>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.booking-request')"/>
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>
    <b-row align-h="center" align-v="center">
      <b-colxx xxs="12">
        <b-card class="mb-4" title="">
          <div class="top-right-button-container mb-2">
            <b-button variant="primary" size="sm" class="top-right-button" @click="allConfirm">선택된 예약신청 일괄승인
            </b-button>
          </div>
          <booking-list
            :pageType="brl"
            :items="items"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @click-row="onClickRow"
            @confirm-proc="confirmBooking"
            @deny-proc="denyBooking"
            @showReq="ShowReqModal"
          />

          <b-pagination v-if="lastPage > 1"
                        size="sm"
                        align="center"
                        :total-rows="total"
                        :per-page="perPage"
                        v-model="currentPage"
          >
            <template v-slot:next-text>
              <i class="simple-icon-arrow-right"/>
            </template>
            <template v-slot:prev-text>
              <i class="simple-icon-arrow-left"/>
            </template>
            <template v-slot:first-text>
              <i class="simple-icon-control-start"/>
            </template>
            <template v-slot:last-text>
              <i class="simple-icon-control-end"/>
            </template>
          </b-pagination>

<!--          <div class="top-right-button-container mb-2">-->
<!--            <b-button variant="primary" size="sm" class="top-right-button" @click="allConfirm">선택된 예약신청 일괄승인-->
<!--            </b-button>-->
<!--          </div>-->


          <b-row align-v="center" align-h="center" class="mt-0 " no-gutters>
            <div class="notooltip">
              <b-modal modal-class="notooltip" id="bookingdetails" ref="bookingdetails" size="lg" title="예약 상태" :hide-backdrop="false"
                          :no-close-on-backdrop="true">
                <booking-details-viewer :data="bookingInfo" :checkUseFlag="false"/>
                <template slot="modal-footer">
                  <b-button variant="outline-primary" @click="hideModal">닫기</b-button>
                  <b-button variant="warning" @click="denyBooking(selectedBookingNo)">예약불가</b-button>
                  <b-button variant="primary" @click="confirmBooking(selectedBookingNo)" class="mr-1">예약승인</b-button>
                </template>
              </b-modal>
            </div>
          </b-row>


          <!--메모 모달-->
          <b-modal id="modalMemo" ref="modalMemo" title="요청사항" size="sm" hide-footer>
            <b-textarea v-model="textMemo" :rows="7" readonly/>
          </b-modal>


        </b-card>
      </b-colxx>
    </b-row>
  </div>

</template>

<script>
  import 'vue-select/dist/vue-select.css'
  import SearchBookingButton from "./components/SearchBookingButton";
  import BookingDetailsViewer from "./components/BookingDetailView";
  import BookingList from './components/BookingList'
  import {_ResponseMSG} from '../../constants/common'
  import api from '../../constants/api'

  import {
    mapGetters,
    mapActions,
    mapMutations
  } from "vuex";
  import {alignTableCenter} from "../../utils";

  export default {
    components: {
      "search-booking-button": SearchBookingButton,
      'booking-details-viewer': BookingDetailsViewer,
      'booking-list': BookingList
    },

    data() {

      return {
        textMemo: null,
        selected_item_no: null,
        isLoad: false,
        currentPage: 1,
        perPage: 30,
        lastPage: 0,
        total: 0,
        bookingId: null,
        fields: [
          {key: 'bookingNo', label: "예약번호", ...alignTableCenter},
          {key: 'storeName', label: "매장명", ...alignTableCenter},
          {key: 'visitorName', label: "예약자", ...alignTableCenter},
          {key: 'visitorPhone', label: "전화번호", ...alignTableCenter},
          {key: 'headcount', label: "인원", ...alignTableCenter},
          {key: 'bookingRequestDate', label: "예약신청일", ...alignTableCenter},
          {key: 'reservationDate', label: "방문예정일", ...alignTableCenter},
          // {key: 'bookingStatus', label: "예약상태", ...alignTableCenter},
          {key: 'visitorRequests', label: "요청사항", ...alignTableCenter},
          {key: 'button', label: "처리", ...alignTableCenter},

        ],
        items: [],
        bookingInfo: [],
        selectedBookingNo: null
      }
    },
    computed: {
      ...mapGetters(['currentUser', 'siteName'])
    },
    mounted() {
      this.searchData()
    },
    watch: {
      currentPage() {
        this.searchData()
      }
    },

    methods: {
      ShowReqModal(item) {
        console.log(item)
        this.selected_item_no = item.bookingNo
        this.textMemo = item.visitorRequests
        this.$refs['modalMemo'].show()
      },
      hideReqModal() {
        this.selected_item_no = null
        this.$refs['modalMemo'].hide()
      },


      searchData() {

        this.isLoad = false

        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingRequestList)
        const params = {pageNumber: this.currentPage - 1, pageSize: this.perPage}

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            const _data = res.data.data
            // console.log(_data)

            this.lastPage = _data.totalPages
            this.total = _data.totalElements;
            this.items = _data.content
            this.isLoad = true

          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },


      //일괄승인
      allConfirm() {
        let flag = false
        let cnt = 0
        let selectedBookingNos = [];
        this.items.forEach(function(value, index) {
          if(value.selected) {
            flag = true
            selectedBookingNos.push(value.bookingNo)
            cnt++
          }
        })
        if(flag === false) {
          alert('일괄승인 할 예약을 선택해주세요.')
          return false
        }
        if(confirm(cnt + '건에 대한 예약신청 일괄 승인 처리를 하시겠습니까?')) {
          this.confirmProcess(selectedBookingNos)
        }
      },
      confirmBooking(BookingNo) { //예약승인
        if(confirm('승인처리 하시겠습니까?')) {
          this.confirmProcess([BookingNo])
        }
      },
      confirmProcess(selectedBookingNos) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.approveBookingRequest)
        const params = {
          bookingNos: selectedBookingNos
        }
        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            alert('승인처리 되었습니다.')
            this.searchData()
            this.$router.go(0)
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },

      denyBooking(BookingNo) { //예약승인 거절
        if(confirm('예약을 거부하시겠습니까?')) {
          this.denyProcess(BookingNo);
        }
      },
      denyProcess(selectedBookingNo) {
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.rejectBookingRequest)
        const params = {
          bookingNo: selectedBookingNo
        }
        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            alert('처리 되었습니다.')
            this.$router.go(0)
          } else {
            throw 400
          }
        }).catch(err => {
          alert(err.response.data.message);
        })
      },


      //상세보기
      onClickRow(item, bookingNo, target) {
        this.selectedBookingNo = bookingNo
        const reqURL = api.changeAPI(this.siteName, api.basicURL + api.order.bookingDetail)
        const params = {
          bookingNo: bookingNo
        }

        this.$http.post(reqURL, params, {
          headers: {'Authorization': `Bearer ${this.currentUser.tokens.access.token}`}
        }).then(res => {
          if(res.data.code === "OK") {
            this.bookingInfo = res.data.data.bookingDetails
          }
        }).catch(err => {
          alert(err.response.data.message);
        })

        this.showModal();
      },


      showModal() {
        this.$refs['bookingdetails'].show();
      },
      hideModal() {
        this.selectedBookingNo = null
        this.$refs['bookingdetails'].hide();
      },


    }
  }
</script>

<style scoped>
  #coloredtext {
    color: blue;
  }
</style>
